// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import { canPlay } from '../../../constants';
import { defaultProps } from '../props';
import type { BaseReactPlayerProps } from '../types';
import { callPlayer, getSDK } from '../utils';

const SDK_URL = 'https://player.vimeo.com/api/player.js';
const SDK_GLOBAL = 'Vimeo';

const cleanUrl = (url) => {
  return url.replace('/manage/videos', '');
};

export class Vimeo extends Component<BaseReactPlayerProps> {
  static defaultProps = defaultProps;

  static forceLoad = true; // Prevent checking isLoading when URL changes

  static canPlay = canPlay.vimeo;

  callPlayer = callPlayer;

  duration = null;

  currentTime = null;

  secondsLoaded = null;

  componentDidMount() {
    this.props.onMount?.(this);
  }

  load(url) {
    this.duration = null;

    getSDK(SDK_URL, SDK_GLOBAL).then((Vimeo) => {
      if (!this.container) return;

      const {
        onReady,
        onPlay,
        onPause,
        onError,
        onEnded,
        onSeek,
        muted,
        loop,
        playing,
        playsinline,
        controls,
        config
      } = this.props;

      this.player = new Vimeo.Player(this.container, {
        url: cleanUrl(url),
        autoplay: playing,
        muted,
        loop,
        playsinline,
        controls,
        ...config.vimeo.playerOptions
      });

      this.player
        .ready()
        .then(() => {
          const iframe = this.container.querySelector('iframe');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
        })
        .catch(onError);

      this.player.on('loaded', () => {
        onReady();
        this.refreshDuration();
      });

      this.player.on('play', () => {
        onPlay();
        this.refreshDuration();
      });

      this.player.on('pause', onPause);
      this.player.on('seeked', (e) => onSeek(e.seconds));
      this.player.on('ended', onEnded);
      this.player.on('error', onError);
      this.player.on('timeupdate', ({ seconds }) => {
        this.currentTime = seconds;
      });
      this.player.on('progress', ({ seconds }) => {
        this.secondsLoaded = seconds;
      });
      this.player.on('bufferstart', this.props.onBuffer);
      this.player.on('bufferend', this.props.onBufferEnd);
      this.player.on('playbackratechange', (e) =>
        this.props.onPlaybackRateChange(e.playbackRate)
      );
    }, this.props.onError);
  }

  refreshDuration() {
    this.player.getDuration().then((duration) => {
      this.duration = duration;
    });
  }

  play() {
    this.callPlayer('play');
  }

  pause() {
    this.callPlayer('pause');
  }

  stop() {
    this.callPlayer('unload');
  }

  seekTo(seconds) {
    this.callPlayer('setCurrentTime', seconds);
  }

  setVolume(fraction) {
    this.callPlayer('setVolume', fraction);
  }

  setLoop(loop) {
    this.callPlayer('setLoop', loop);
  }

  setPlaybackRate(rate) {
    this.callPlayer('setPlaybackRate', rate);
  }

  mute = () => {
    this.setVolume(0);
  };

  unmute = () => {
    const { volume } = this.props;

    if (volume !== null) {
      this.setVolume(volume);
    }
  };

  getDuration() {
    return this.duration;
  }

  getCurrentTime() {
    return this.currentTime;
  }

  getSecondsLoaded() {
    return this.secondsLoaded;
  }

  ref = (container) => {
    this.container = container;
  };

  render() {
    const { display, url } = this.props;

    const style = {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      display
    };

    return <div key={url} ref={this.ref} style={style} />;
  }
}
